import { render } from "./OverviewPeople.vue?vue&type=template&id=09a3f02b"
import script from "./OverviewPeople.vue?vue&type=script&lang=js"
export * from "./OverviewPeople.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__